export default __webpack_public_path__ + "static/media/done-white.d9dd2fdd.svg";